var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"id":"dashboard","fluid":"","tag":"section"}},[_c('h2',{staticStyle:{"position":"absolute","top":"40%","left":"50%","font-size":"2rem","transform":"translate(-50%, -50%)","margin":"0","padding":"10px"}},[_vm._v("Welcome to Admin Dashboard")])])
}
var staticRenderFns = []

export { render, staticRenderFns }